import { Component, Inject, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WarehouseSelectorComponent } from 'src/app/common/warehouse-selector/warehouse-selector.component';

@Component({
  templateUrl: './warehouse-select-dialog.component.html'
})
export class WarehouseSelectDialog implements AfterViewInit {
  @ViewChild(WarehouseSelectorComponent)
  WarehouseSelector?: WarehouseSelectorComponent;
  message: string = "Select a Warehouse";
  icon = '';
  cancelButtonText = "Cancel";
  buttonText = "OK";

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: {
      message: string,
      icon: string,
      cancelButtonText: string,
      buttonText: string,
      warehouseIDs: string[]
    },
    private dialogRef: MatDialogRef<WarehouseSelectDialog>
  ) {
    if (data) {
      this.message = data.message || this.message;
      if (data.icon) this.icon = data.icon;
      if (data.buttonText) {
        this.buttonText = data.buttonText || this.buttonText;
      }
    }
  }
  ngAfterViewInit(): void {
    if (this.data.warehouseIDs) setTimeout(() => {
      this.WarehouseSelector!.setOptions(this.data.warehouseIDs);
    });
  }

  onCloseClick(response: string | null): void {
    this.dialogRef.close(response);
  }
}